'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reseller = require('../actions/reseller');

var _reseller_list = require('../components/reseller_list');

var _reseller_list2 = _interopRequireDefault(_reseller_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resellers = _react2.default.createClass({
  displayName: 'Resellers',

  propTypes: {
    resellers: _react.PropTypes.object.isRequired,
    dispatch: _react.PropTypes.func.isRequired
  },
  componentWillMount: function componentWillMount() {
    var dispatch = this.props.dispatch;

    dispatch((0, _reseller.fetchResellersData)());
  },
  onPageChange: function onPageChange(page) {
    // 页码改变
    var dispatch = this.props.dispatch;

    dispatch((0, _reseller.fetchResellersData)(page));
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { id: 'resellers', className: 'clearfix' },
      _react2.default.createElement(_reseller_list2.default, { data: this.props.resellers, onChange: this.onPageChange })
    );
  }
});

var mapStateToProps = function mapStateToProps(store) {
  var resellers = store.reseller.resellers;

  return {
    resellers: resellers
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Resellers);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/resellers.js
// module id = 1573
// module chunks = 0